// @mui
import { Typography, Stack } from '@mui/material';
// hooks
import { useCountdown } from '@/hooks';
// utils
import { formatDateTime } from '@/utils/formatTime';
// enums
import { EVENT_PROGRESS } from '@/enums';

export default function ContentRemainingTime({ startDate, endDate, progress }) {
  const [{ days, hours, minutes, seconds }] = useCountdown(startDate);

  return progress === EVENT_PROGRESS.UPCOMING ? (
    <Stack direction="row" sx={{ color: 'secondary.main' }} spacing={1}>
      {days > 0 && <Typography>{days} days</Typography>}
      {(days > 0 || hours > 0) && <Typography>{hours} hours</Typography>}
      {(days > 0 || hours > 0 || minutes > 0) && <Typography>{minutes} mins</Typography>}
      {(days > 0 || hours > 0 || minutes > 0 || seconds > 0) && (
        <Typography>{seconds} secs remaining.</Typography>
      )}
    </Stack>
  ) : (
    progress === EVENT_PROGRESS.NOW && (
      <Stack direction="row" sx={{ color: 'secondary.main' }} spacing={1}>
        <Typography>Continuing until {formatDateTime(endDate)}</Typography>
      </Stack>
    )
  );
}
